import React from 'react';
import Carousel from '../components/Carousel';
import Features from '../components/Features';
import Programs from '../components/Programs';
import Contact from './Contact';



const Home = () => {
    return (
        <>
            <main className="home container">
                <div className="hero">
                    <Carousel/>
                </div>
                <section id="features">
                    <Features/>
                </section>
                <section id="programs">
                    <Programs/>
                </section>
                <section id="contact">
                    <Contact/>
                </section>

            </main>
        </>
    );
}

export default Home;